import React from 'react';
import './ConfirmationDialog.css';

export interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'info' | 'warning' | 'danger';
  title: string;
  message: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  onPrimaryAction: () => void;
  onSecondaryAction?: () => void;
  showIcon?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  type,
  title,
  message,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryAction,
  onSecondaryAction,
  showIcon = true
}) => {
  if (!isOpen) return null;

  const getIconColor = () => {
    switch (type) {
      case 'info':
        return '#007bff';
      case 'warning':
        return '#ffc107';
      case 'danger':
        return '#dc3545';
      default:
        return '#007bff';
    }
  };

  const getPrimaryButtonClass = () => {
    switch (type) {
      case 'info':
        return 'confirmation-dialog-btn-primary';
      case 'warning':
        return 'confirmation-dialog-btn-warning';
      case 'danger':
        return 'confirmation-dialog-btn-danger';
      default:
        return 'confirmation-dialog-btn-primary';
    }
  };

  const handlePrimaryAction = () => {
    onPrimaryAction();
    onClose();
  };

  const handleSecondaryAction = () => {
    if (onSecondaryAction) {
      onSecondaryAction();
    }
    onClose();
  };

  return (
    <div className="confirmation-dialog-overlay" onClick={onClose}>
      <div className="confirmation-dialog-container" onClick={(e) => e.stopPropagation()}>
        <button className="confirmation-dialog-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {showIcon && (
          <div className="confirmation-dialog-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="20" fill={getIconColor()} fillOpacity="0.1"/>
              <circle cx="24" cy="24" r="16" fill={getIconColor()} fillOpacity="0.2"/>
              <path d="M24 16v8M24 28h.01" stroke={getIconColor()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        )}

        <h2 className="confirmation-dialog-title">{title}</h2>
        <p className="confirmation-dialog-message">{message}</p>

        <div className="confirmation-dialog-actions">
          {secondaryButtonText && (
            <button 
              className="confirmation-dialog-btn-secondary"
              onClick={handleSecondaryAction}
            >
              {secondaryButtonText}
            </button>
          )}
          <button 
            className={`confirmation-dialog-btn ${getPrimaryButtonClass()}`}
            onClick={handlePrimaryAction}
          >
            {primaryButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog; 